import { render, staticRenderFns } from "./DemoSimpleTableDark.vue?vue&type=template&id=36a6b758&"
import script from "./DemoSimpleTableDark.vue?vue&type=script&lang=js&"
export * from "./DemoSimpleTableDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
